
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.51 14.666H7.49a.674.674 0 00-.681.667c0 .369.305.667.68.667h17.022c.376 0 .68-.298.68-.667a.674.674 0 00-.68-.667zM7.49 10.667h6.808c.376 0 .68-.298.68-.667a.674.674 0 00-.68-.666H7.489a.674.674 0 00-.68.666c0 .369.305.667.68.667zM24.51 20H7.49a.674.674 0 00-.681.667c0 .368.305.666.68.666h17.022c.376 0 .68-.298.68-.666a.674.674 0 00-.68-.667zM24.51 25.334H7.49a.674.674 0 00-.681.666c0 .369.305.667.68.667h17.022c.376 0 .68-.298.68-.667a.674.674 0 00-.68-.666zM24.51 30.666H7.49a.674.674 0 00-.681.667c0 .369.305.667.68.667h17.022c.376 0 .68-.298.68-.667a.674.674 0 00-.68-.666z","fill":"#323232"}}),_c('path',{attrs:{"d":"M22.07 0H0v40h32V9.724L22.07 0zm.398 2.276l7.208 7.057h-7.208V2.276zM1.362 38.666V1.334h19.744v9.334h9.532v28H1.362z","fill":"#323232"}})])
          )
        }
      }
    